export const noop = (): void => null;

export const noopPromise = <T extends unknown>(...args: unknown[]): PromiseLike<T> => new Promise((resolve) => {
	resolve(null);
});
